import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Api from 'utils/api';

class Transactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = { transactions: null };
  };

  componentWillMount = () => {
    const api = new Api({ baseUrl: 'http://localhost:3001/api' });
    api.fetchTransactions()
      .then((transactions) => {
        this.setState({ transactions });
      });
  };

  renderTransaction = (transaction) => {
    return (
      <TableRow key={transaction.bank_transaction_id}>
        <TableCell>
          {transaction.type}
        </TableCell>
        <TableCell>
          {transaction.bank_transaction_id}
        </TableCell>
        <TableCell>
          {transaction.reference}
        </TableCell>
        <TableCell>
          {transaction.status}
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { transactions } = this.state;

    return (
      <Table>
        <TableBody>
          { transactions && transactions.map((transaction) => this.renderTransaction(transaction))}
        </TableBody>
      </Table>
    )
  }
}

export default Transactions;



// WEBPACK FOOTER //
// ./src/components/Transactions/index.js